import {
	OrganizationDetails,
	OrgSettingsOrganizationDetailsActions,
	ORG_SETTINGS_ORGANIZATION_DETAIL_TYPES,
} from './types'

const initialState: OrganizationDetails = {
	educationalContent: [],
}

export default (
	state: OrganizationDetails = initialState,
	action: OrgSettingsOrganizationDetailsActions
): OrganizationDetails => {
	switch (action.type) {
		case ORG_SETTINGS_ORGANIZATION_DETAIL_TYPES.GET:
			return {
				...state,
				...action.payload,
			}
		default:
			return state
	}
}
